import * as moment from 'moment';

export class Passport {
    id: number;
    expiration: any;
    biometric: boolean;
    serial: string;
    clientId?: number;
    file?: string;

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    // this.expiration = apiModel.expiration;
    this.expiration = apiModel.expiration && apiModel.expiration !== 'Invalid date' ? moment(apiModel.expiration).format('DD.MM.YYYY') : '',
    this.biometric = apiModel.is_biometric;
    this.serial = apiModel.serial;
    this.clientId = apiModel.client_id;
    this.file = apiModel.file;

    return this;
  }
}
